// extracted by mini-css-extract-plugin
export default {"links":"LinkTree_links__rDaMV","link":"LinkTree_link__aJdLQ"};